import React from 'react';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { MessageSquare, UserPlus, X } from 'lucide-react';
import { cn } from '@/lib/utils';

interface NetworkingNotificationBannerProps {
  unreadMessages: number;
  pendingRequests: number;
  onNavigateToMessages?: () => void;
  onNavigateToRequests?: () => void;
  className?: string;
}

export const NetworkingNotificationBanner: React.FC<NetworkingNotificationBannerProps> = ({
  unreadMessages,
  pendingRequests,
  onNavigateToMessages,
  onNavigateToRequests,
  className
}) => {
  const [isVisible, setIsVisible] = React.useState(true);
  
  if (!unreadMessages && !pendingRequests) {
    return null;
  }
  
  const hasNotifications = unreadMessages > 0 || pendingRequests > 0;

  if (!hasNotifications || !isVisible) {
    return null;
  }

  return (
    <Card className={cn(
      "sticky top-0 z-10 mb-4 border-l-4",
      unreadMessages > 0 ? "border-l-destructive bg-destructive/5" : "border-l-primary bg-primary/5",
      className
    )}>
      <div className="flex items-center justify-between p-4">
        <div className="flex items-center gap-4 flex-1">
          {unreadMessages > 0 && (
            <Button
              variant="ghost"
              size="sm"
              onClick={onNavigateToMessages}
              className="flex items-center gap-2 hover:bg-background/80"
            >
              <MessageSquare className="h-5 w-5 text-destructive" />
              <span className="font-medium">Messages non lus</span>
              <Badge variant="destructive" className="ml-1">
                {unreadMessages}
              </Badge>
            </Button>
          )}
          
          {pendingRequests > 0 && (
            <Button
              variant="ghost"
              size="sm"
              onClick={onNavigateToRequests}
              className="flex items-center gap-2 hover:bg-background/80"
            >
              <UserPlus className="h-5 w-5 text-primary" />
              <span className="font-medium">Demandes en attente</span>
              <Badge variant="default" className="ml-1">
                {pendingRequests}
              </Badge>
            </Button>
          )}
        </div>

        <Button
          variant="ghost"
          size="icon"
          onClick={() => setIsVisible(false)}
          className="h-8 w-8"
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
    </Card>
  );
};
